import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import type {RootState, AppDispatch} from '@/store';

/**
 * Typed Redux hooks for use throughout the application
 * Following Redux Toolkit best practices for TypeScript integration
 */

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Export for convenience
export type {RootState, AppDispatch};
